<template>

<div class="referral">

	<div class="referral-overlay" v-on:click="$emit('close')"></div>

	<div class="referral-panel">

		<div class="referral-header">

			<div class="referral-title">Referral Letter Notes</div>

			<button class="referral-close" v-on:click="$emit('close')">&times;</button>

		</div>

		<div class="referral-body">

			<div class="referral-content" ref="content">

				<div class="referral-section" v-if="reasonText">
					<div class="referral-section-title">Reason for referral</div>
					<div class="referral-section-text" v-html="reasonText"></div>
				</div>

				<div class="referral-section" v-if="!reasonText">
					<div class="referral-section-title">Reason for referral</div>
					<div class="referral-section-text referral-placeholder">[Please insert reason for referral]</div>
				</div>

				<div class="referral-section" v-if="fields.length">
					<div class="referral-section-title">Patient Details</div>
					<div class="referral-field" v-for="(field, index) in fields" :key="index">
						{{ field }}
					</div>
				</div>

			</div>

		</div>

		<div class="referral-footer">

			<button class="referral-button" v-on:click="onCopyClick">{{ copied ? 'Copied' : 'Copy to Clipboard' }}</button>

			<button class="referral-button referral-button-download" v-on:click="onDownloadClick">Download as Text</button>

		</div>

	</div>

</div>

</template>

<script>

export default {

	props: ['recommendation'],

	data: function() {

		return {
			copied: false
		}

	},

	computed: {

		referral: function() {

			return this.$store.getters['data/bridge/referral']

		},

		blocks: function() {

			return this.$store.getters['data/decision/blocks']

		},

		recommendationBlocks: function() {

			var rec = this.recommendation
			var blockIds = []

			if (rec.summary.enabled === this.$constants.recommendation.text.blocks) {
				blockIds = blockIds.concat(rec.summary.blocks)
			}

			if (rec.reason.enabled === this.$constants.recommendation.text.blocks) {
				blockIds = blockIds.concat(rec.reason.blocks)
			}

			if (rec.information.enabled === this.$constants.recommendation.text.blocks) {
				blockIds = blockIds.concat(rec.information.blocks)
			}

			return blockIds

		},

		reasonText: function() {

			var self = this

			var matchedReason = null

			this.$_.each(this.referral.reasons, function(reason) {

				if (matchedReason) return

				var hasVisibleBlock = self.$_.some(reason.blocks, function(blockId) {

					if (!self.$_.contains(self.recommendationBlocks, blockId)) return false

					var block = self.blocks[blockId]

					if (!block) return false

					if (block.visibility.enabled === self.$constants.visibility.always) return true

					if (block.visibility.enabled === self.$constants.visibility.sometimes) {
						return self.$store.getters['logic/evaluate'](block.visibility.logic)
					}

					return false

				})

				if (hasVisibleBlock) {
					matchedReason = reason
				}

			})

			return matchedReason ? matchedReason.text : null

		},

		fraxAdjusted: function() {

			var adjustedMof = this.$getValue('system.1a')
			var adjustedHip = this.$getValue('system.1b')
			var rawMof = this.$store.getters['logic/variable'](53)
			var rawHip = this.$store.getters['logic/variable'](54)

			var isAdjusted = (adjustedMof !== null && rawMof !== null && parseFloat(adjustedMof) !== parseFloat(rawMof)) || (adjustedHip !== null && rawHip !== null && parseFloat(adjustedHip) !== parseFloat(rawHip))

			if (!isAdjusted) return null

			var reasons = []
			if (this.$getValue('ref.dose')) reasons.push('steroid use')
			if (this.$getValue('ref.falls')) reasons.push('falls')
			var lumbar = this.$store.getters['logic/variable'](62)
			var femoral = this.$store.getters['logic/variable'](63)
			if (lumbar !== null && femoral !== null && (parseFloat(lumbar) - parseFloat(femoral)) >= 1) reasons.push('lumbar BMD')

			return reasons.length ? reasons.join(', ') : 'clinical factors'

		},

		fields: function() {

			var self = this
			var result = []
			var fraxFieldIds = [53, 54]

			this.$_.each(this.referral.fields, function(field) {

				var include = true

				if (field.condition.enabled === self.$constants.visibility.sometimes) {
					include = self.$store.getters['logic/evaluate'](field.condition.logic)
				}

				if (!include) return

				var value = self.$store.getters['logic/variable'](field.variable)
				var variable = self.$store.getters['data/setup/variables'][field.variable]
				var displayValue

				if (value === null || value === undefined) {
					displayValue = field.empty || 'unknown'
				} else if (variable && variable.type === self.$constants.logic.variable.type.boolean) {
					displayValue = value ? 'Yes' : 'No'
				} else if (variable && variable.type === self.$constants.logic.variable.type.option && variable.values[value]) {
					displayValue = variable.values[value]
				} else {
					displayValue = String(value)
				}

				if (self.$_.contains(fraxFieldIds, field.variable) && self.fraxAdjusted && value !== null) {

					var adjustedValue = (field.variable === 53) ? self.$getValue('system.1a') : self.$getValue('system.1b')

					if (adjustedValue !== null) {
						result.push(field.label + ': ' + String(Math.round(parseFloat(adjustedValue) * 10) / 10) + '. Adjusted FRAX (adjusted for ' + self.fraxAdjusted + ')')
					} else {
						result.push(field.label + ': ' + displayValue + ' unadjusted')
					}

				} else if (self.$_.contains(fraxFieldIds, field.variable) && value !== null) {

					result.push(field.label + ': ' + displayValue + ' unadjusted')

				} else if (field.format) {
					result.push(field.format.replace('{label}', field.label).replace('{value}', displayValue))
				} else {
					result.push(field.label + ': ' + displayValue)
				}

			})

			return result

		},

		plainText: function() {

			var lines = []

			lines.push('Reason for referral')
			lines.push(this.reasonText ? this.stripHtml(this.reasonText) : '[Please insert reason for referral]')
			lines.push('')

			if (this.fields.length) {
				lines.push('Patient Details')
				this.$_.each(this.fields, function(field) {
					lines.push(field)
				})
			}

			return lines.join('\n')

		}

	},

	methods: {

		stripHtml: function(html) {

			var tmp = document.createElement('div')
			tmp.innerHTML = html
			return tmp.textContent || tmp.innerText || ''

		},

		onCopyClick: function() {

			var textarea = document.createElement('textarea')
			textarea.value = this.plainText
			textarea.style.position = 'fixed'
			textarea.style.opacity = '0'
			document.body.appendChild(textarea)
			textarea.select()
			document.execCommand('copy')
			document.body.removeChild(textarea)

			this.copied = true
			this.$emit('used')

			setTimeout(function() {
				this.copied = false
			}.bind(this), 2000)

		},

		onDownloadClick: function() {

			var blob = new Blob([this.plainText], { type: 'text/plain' })
			var url = URL.createObjectURL(blob)
			var a = document.createElement('a')
			a.href = url
			a.download = 'referral-notes.txt'
			a.click()
			URL.revokeObjectURL(url)
			this.$emit('used')

		}

	}

}

</script>

<style scoped>

.referral {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 2000;
	display: flex;
	align-items: center;
	justify-content: center;
}

.referral-overlay {
	position: absolute;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
}

.referral-panel {
	position: relative;
	background-color: #fff;
	border-radius: 16px;
	width: 90%;
	max-width: 700px;
	max-height: 90vh;
	display: flex;
	flex-direction: column;
	overflow: hidden;
}

.is-mobile .referral-panel {
	width: 100%;
	max-width: 100%;
	max-height: 100%;
	height: 100%;
	border-radius: 0;
}

.referral-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 24px 32px;
	border-bottom: 1px solid #e0e0e0;
}

.is-mobile .referral-header {
	padding: 16px 20px;
}

.referral-title {
	font-size: 20px;
	font-weight: 700;
	color: #343434;
}

.is-mobile .referral-title {
	font-size: 16px;
}

.referral-close {
	font-size: 28px;
	color: #999;
	cursor: pointer;
	line-height: 1;
	background: none;
	border: none;
}

.referral-close:hover {
	color: #343434;
}

.referral-body {
	flex: 1;
	overflow-y: auto;
	padding: 32px;
}

.is-mobile .referral-body {
	padding: 20px;
}

.referral-section {
	margin-bottom: 24px;
}

.referral-section-title {
	font-size: 14px;
	font-weight: 700;
	color: #343434;
	text-transform: uppercase;
	letter-spacing: 0.5px;
	margin-bottom: 8px;
}

.referral-section-text {
	font-size: 14px;
	color: #343434;
	line-height: 22px;
}

.referral-placeholder {
	color: #999;
	font-style: italic;
}

.referral-field {
	font-size: 14px;
	color: #343434;
	line-height: 24px;
	padding: 2px 0;
}

.referral-footer {
	display: flex;
	justify-content: flex-end;
	gap: 12px;
	padding: 20px 32px;
	border-top: 1px solid #e0e0e0;
}

.is-mobile .referral-footer {
	padding: 16px 20px;
	flex-direction: column;
}

.is-mobile .referral-button {
	width: 100%;
	text-align: center;
}

.referral-button {
	padding: 12px 24px;
	background-color: var(--primary-color);
	color: #fff;
	border: none;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 600;
	cursor: pointer;
	transition: all 200ms ease-in-out;
}

.referral-button:hover {
	filter: brightness(90%);
}

.referral-button-download {
	background-color: #f0f0f0;
	color: #343434;
	border: 1px solid #ddd;
}

.referral-button-download:hover {
	background-color: #e0e0e0;
	filter: none;
}

</style>
